"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAlipay = createAlipay;
exports.createWechatPay = createWechatPay;
exports.deleteAlipay = deleteAlipay;
exports.deleteWechatPay = deleteWechatPay;
exports.disableAlipay = disableAlipay;
exports.disableWechatPay = disableWechatPay;
exports.enableAlipay = enableAlipay;
exports.enableWechatPay = enableWechatPay;
exports.getAlipayDetail = getAlipayDetail;
exports.getAlipayList = getAlipayList;
exports.getWechatPayDetail = getWechatPayDetail;
exports.getWechatPayList = getWechatPayList;
exports.updateAlipay = updateAlipay;
exports.updateWechatPay = updateWechatPay;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// 查询微信支付商户列表
function getWechatPayList(query) {
  return (0, _request.default)({
    url: '/admin/platform/wechatpay/merchant/list',
    method: 'GET',
    params: query
  });
}

// 获取微信支付商户
function getWechatPayDetail(id) {
  return (0, _request.default)({
    url: "/admin/platform/wechatpay/merchant/detail/".concat(id),
    method: 'GET'
  });
}

// 新增微信支付商户
function createWechatPay(data) {
  return (0, _request.default)({
    url: '/admin/platform/wechatpay/merchant/add',
    method: 'POST',
    data: data
  });
}

// 修改微信支付商户
function updateWechatPay(data) {
  return (0, _request.default)({
    url: '/admin/platform/wechatpay/merchant/update',
    method: 'POST',
    data: data
  });
}
function enableWechatPay(id) {
  return (0, _request.default)({
    url: "/admin/platform/wechatpay/merchant/enable/".concat(id),
    method: 'POST'
  });
}
function disableWechatPay(id) {
  return (0, _request.default)({
    url: "/admin/platform/wechatpay/merchant/disable/".concat(id),
    method: 'POST'
  });
}

// 删除微信支付商户
function deleteWechatPay(id) {
  return (0, _request.default)({
    url: "/admin/platform/wechatpay/merchant/delete/".concat(id),
    method: 'POST'
  });
}

// 查询支付宝商户列表
function getAlipayList(query) {
  return (0, _request.default)({
    url: '/admin/platform/alipay/merchant/list',
    method: 'GET',
    params: query
  });
}

// 获取支付宝商户
function getAlipayDetail(id) {
  return (0, _request.default)({
    url: "/admin/platform/alipay/merchant/detail/".concat(id),
    method: 'GET'
  });
}

// 新增支付宝商户
function createAlipay(data) {
  return (0, _request.default)({
    url: '/admin/platform/alipay/merchant/add',
    method: 'POST',
    data: data
  });
}

// 修改支付宝商户
function updateAlipay(data) {
  return (0, _request.default)({
    url: '/admin/platform/alipay/merchant/update',
    method: 'POST',
    data: data
  });
}
function enableAlipay(id) {
  return (0, _request.default)({
    url: "/admin/platform/alipay/merchant/enable/".concat(id),
    method: 'POST'
  });
}
function disableAlipay(id) {
  return (0, _request.default)({
    url: "/admin/platform/alipay/merchant/disable/".concat(id),
    method: 'POST'
  });
}

// 删除支付宝商户
function deleteAlipay(id) {
  return (0, _request.default)({
    url: "/admin/platform/alipay/merchant/delete/".concat(id),
    method: 'POST'
  });
}